import {
  FEEDBACK_ALERT_ICONS,
  FEEDBACK_ALERT_STYLES
} from '../constants/feedbackAlertConstants'

export function resolveFeedbackAlertStyle(severity = 'error', colors) {
  return {
    ...(FEEDBACK_ALERT_STYLES[severity] || FEEDBACK_ALERT_STYLES.error),
    ...colors
  }
}

export function resolveFeedbackAlertIcon(severity = 'error', icon) {
  return icon ?? FEEDBACK_ALERT_ICONS[severity] ?? FEEDBACK_ALERT_ICONS.error
}

export function buildFeedbackAlertSx(
  style,
  durationMs,
  {
    inline = false,
    isMobileLayout = false,
    position = {},
    progressKeyframeName = 'feedbackAlertProgress',
    width,
    minWidth,
    minHeight,
    mt,
    mb,
    px,
    py,
    borderRadius = '12px',
    boxShadow = inline ? '0 8px 20px rgba(14, 36, 56, 0.1)' : '0 12px 32px rgba(14, 36, 56, 0.14)',
    messageFontSize,
    messageLineHeight,
    messagePaddingRight,
    iconFontSize,
    iconMarginRight,
    closeButtonMinimal = false,
    extraSx = {}
  } = {}
) {
  return {
    position: position.type || 'relative',
    right: position.right,
    top: position.top,
    transform: position.transform,
    zIndex: position.zIndex,
    overflow: 'hidden',
    width: width ?? '100%',
    maxWidth: '100%',
    minWidth: minWidth ?? (inline ? 0 : { sm: 440 }),
    minHeight,
    mx: 0,
    mt,
    mb: mb ?? (inline ? 0 : undefined),
    px: px ?? 2,
    py: py ?? 1.25,
    border: `${style.borderWidth}px solid ${style.border}`,
    borderRadius,
    backgroundColor: style.background,
    color: style.text,
    boxShadow,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    [`@keyframes ${progressKeyframeName}`]: {
      from: { transform: 'scaleX(1)' },
      to: { transform: 'scaleX(0)' }
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '100%',
      height: 3,
      backgroundColor: style.border,
      transformOrigin: 'left center',
      animation: `${progressKeyframeName} ${durationMs}ms linear forwards`,
      pointerEvents: 'none'
    },
    '& .MuiAlert-icon': {
      color: style.icon,
      fontSize: iconFontSize ?? (isMobileLayout ? 20 : 22),
      p: 0,
      mr: iconMarginRight ?? (isMobileLayout ? 1 : 1.25),
      opacity: 1
    },
    '& .MuiAlert-message': {
      flex: '1 1 auto',
      py: 0,
      pr: messagePaddingRight ?? (isMobileLayout ? 1 : 1.5),
      fontSize: messageFontSize ?? (isMobileLayout ? 13 : 14),
      fontWeight: style.fontWeight,
      lineHeight: messageLineHeight ?? 1.4,
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-line'
    },
    '& .MuiAlert-action': {
      alignItems: 'center',
      color: style.text,
      m: 0,
      p: 0,
      pl: 0.5,
      ml: 0,
      backgroundColor: closeButtonMinimal ? 'transparent' : undefined
    },
    '& .MuiIconButton-root': {
      p: 0.25,
      color: style.text,
      backgroundColor: closeButtonMinimal ? 'transparent !important' : undefined,
      border: closeButtonMinimal ? 'none !important' : undefined,
      boxShadow: closeButtonMinimal ? 'none !important' : undefined,
      minWidth: closeButtonMinimal ? 'auto !important' : undefined,
      width: closeButtonMinimal ? 'auto !important' : undefined,
      height: closeButtonMinimal ? 'auto !important' : undefined,
      '&:hover': {
        backgroundColor: closeButtonMinimal ? 'transparent !important' : undefined,
        boxShadow: closeButtonMinimal ? 'none !important' : undefined
      }
    },
    '& .MuiSvgIcon-root': {
      fontSize: isMobileLayout ? 18 : 20
    },
    ...extraSx
  }
}
